import { TReapitSyncNegotiatorExtendedData } from "types/reapit.type";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { BasicUserInfo, IntegrationEntitySyncTag } from "components";
import { ReapitNegotiatorSyncSelect } from "./ReapitNegotiatorSyncSelect";
import { ITableV2Column } from "components/table-v2/table-v2";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";

export const syncReapitNegotiatorTableColumnDef = (
  accountStore: UserAccountStore,
  updateSyncPair: (syncPair: TReapitSyncNegotiatorExtendedData) => void
): ITableV2Column<TReapitSyncNegotiatorExtendedData>[] => {
  return [
    {
      accessor: "userFullName",
      Header: <DefaultHeaderCell>LeadPro user</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <BasicUserInfo user={row.user} />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "reapitId",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>Reapit negotiator</DefaultHeaderCell>,
      Cell: ({ row }) => {
        const onChange = (reapitId: string | null) => {
          updateSyncPair({
            reapitId,
            syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
            userAccountId: row.userAccountId,
            user: row.user,
            userFullName: row.userFullName,
          });
        };
        return (
          <DefaultRowCell>
            <ReapitNegotiatorSyncSelect
              accountStore={accountStore}
              value={row.reapitId}
              onChange={onChange}
            />
          </DefaultRowCell>
        );
      },
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
